import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { navLinks } from "@/mocks/site";

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState("");

  const submitSearch = (value: string) => {
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
    setSearchOpen(false);
    setQuery("");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
      isActive
        ? "bg-primary-100 font-semibold text-primary-700"
        : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 cursor-pointer items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-clapperboard-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-black tracking-tight text-primary-700">欧美一级视频</span>
            <span className="font-label text-[10px] uppercase tracking-[0.2em] text-foreground-500">
              OMV · Movies
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <NavLink key={link.to} to={link.to} end={link.to === "/"} className={linkClass}>
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch(query);
            }}
            className="flex h-10 items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索影视作品…"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 xl:w-56"
            />
          </form>
        </div>

        <div className="flex items-center gap-1 lg:hidden">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => setSearchOpen(true)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100"
          >
            <i className="ri-search-line text-xl"></i>
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `cursor-pointer rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-100 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      ) : null}

      {searchOpen ? (
        <div className="fixed inset-0 z-[60] bg-background-950/40 lg:hidden">
          <div className="bg-background-50 p-4">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                submitSearch(query);
              }}
              className="flex items-center gap-2"
            >
              <div className="flex h-11 flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
                <i className="ri-search-line text-base text-foreground-500"></i>
                <input
                  autoFocus
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜索影视作品…"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
                />
              </div>
              <button
                type="submit"
                className="flex h-11 shrink-0 cursor-pointer items-center rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50"
              >
                搜索
              </button>
              <button
                type="button"
                aria-label="关闭搜索"
                onClick={() => setSearchOpen(false)}
                className="flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-background-100"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </form>
          </div>
        </div>
      ) : null}
    </header>
  );
}